import Icon from 'veui/components/Icon'
import { IconExclamationCircleSolid } from 'dls-icons-vue'

Icon.register('exclamation-circle-solid', IconExclamationCircleSolid)
